import React from "react"
import styled from "@emotion/styled"

interface Props {
  top: React.ReactNode
  body: React.ReactNode
  bottom?: React.ReactNode
}

export function AppLayout({ top, body, bottom }: Props) {
  return (
    <Outer>
      <Top>{top}</Top>
      <Body
        style={{
          height: `calc(100% ${top ? "- 60px" : ""} ${
            bottom ? "- 100px" : ""
          })`,
        }}
      >
        {body}
      </Body>
      {bottom && <Bottom>{bottom}</Bottom>}
    </Outer>
  )
}

const Outer = styled.div`
  width: 100%;
  height: 100%;
`

const Top = styled.div`
  min-height: 60px;
  width: 100%;
  position: sticky;
`

const Body = styled.div`
  align-items: stretch;
  display: flex;
  overflow-y: auto;
`

const Bottom = styled.div`
  min-height: 100px;
  width: 100%;
  position: absolute;
  background-color: white;
  bottom: 0;
`
